import { jsx, Fragment } from 'react/jsx-runtime';
import React__default, { forwardRef, useRef, useMemo } from 'react';
import { SelectList } from '../../SelectList/SelectList.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';

const MenuOptionsCore = ({ locale, selected, handleSelect, maxMenuItems, children, ...props }, ref)=>{
    const [{ role, open, menuLoading }] = useMenuContext();
    const divRef = useRef(null);
    const items = useMemo(()=>{
        if (Array.isArray(children)) {
            return jsx(Fragment, {
                children: children.filter((item)=>/*#__PURE__*/ React__default.isValidElement(item)).map((item, index)=>/*#__PURE__*/ React__default.cloneElement(item, {
                        key: index,
                        handleSelect
                    }))
            });
        }
        if (/*#__PURE__*/ React__default.isValidElement(children)) {
            return /*#__PURE__*/ React__default.cloneElement(children, {
                handleSelect
            });
        }
        return null;
    }, [
        children,
        handleSelect
    ]);
    const localeWithFallback = useMemo(()=>({
            noItemsMessage: 'No items available.',
            ...locale
        }), [
        locale
    ]);
    if (menuLoading) {
        return jsx(SelectList.Loading, {});
    }
    if (items == null) {
        return jsx(SelectList.NoItems, {
            "data-testid": "no-items-message",
            children: localeWithFallback.noItemsMessage
        });
    }
    return jsx("div", {
        ref: ref,
        role: role,
        ...props,
        children: open ? jsx(SelectList, {
            className: "transition-all duration-100",
            "data-testid": "select-list",
            fixedHeight: false,
            innerRef: divRef,
            maxMenuItems: maxMenuItems,
            selected: selected,
            children: items
        }) : null
    });
};
const MenuOptionsForwardRef = /*#__PURE__*/ forwardRef(MenuOptionsCore);
MenuOptionsForwardRef.displayName = 'MenuV2.Options';
const MenuOptions = MenuOptionsForwardRef;

export { MenuOptions, MenuOptionsCore, MenuOptionsForwardRef };
//# sourceMappingURL=Menu.Options.es.js.map
